import { ModalDescription } from '@src/common/components/modal/ModalDescription';
import { useTranslation } from 'react-i18next';

type Props = {
  jurisdiction: string;
  permitType: string;
  stateId?: string;
};

export const ModelPermitDescription = (props: Props) => {
  const { t } = useTranslation();

  return (
    <ModalDescription
      labelsToValue={[
        {
          label: t('permitApplication.description.jurisdiction'),
          value: props.jurisdiction,
        },
        {
          label: t('permitApplication.description.permitType'),
          value: props.permitType,
        },
        {
          label: t('permitApplication.description.stateId'),
          value: props.stateId ?? '-',
        },
      ]}
    />
  );
};
